<script setup>
import { useI18n } from 'vue-i18n';
import { AGENT_PROFILE_COVER_STYLE } from 'dashboard/constants/agentProfileCover';

defineProps({
  heightClass: {
    type: String,
    default: 'h-28',
  },
  roundedClass: {
    type: String,
    default: 'rounded-t-[1.85rem]',
  },
});

const { t } = useI18n();
</script>

<template>
  <div
    class="w-full shrink-0 overflow-hidden bg-n-brand"
    :class="[heightClass, roundedClass]"
    :style="AGENT_PROFILE_COVER_STYLE"
    role="img"
    :aria-label="t('AGENT_HUB.COVER_ALT')"
  />
</template>
